import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Carousel, Col, Container, Placeholder, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Button, Label } from "semantic-ui-react";
import { useMyGlobal } from "./GlobalData";
import ProductCard from "./ProductCard";


export const DiscountedProduct = ({ data }) => {
    const { wishData } = useMyGlobal()
    const navigate = useNavigate()
    const itemsPerCarousel = 6;
    const groupedData = [];
    const [dscPlaceholder, setDscPlaceholder] = useState(true)
    const [dataPopulated, setDataPopulated] = useState(false)

    for (let i = 0; i < data.length; i += itemsPerCarousel) {
        groupedData.push(data.slice(i, i + itemsPerCarousel));
    }

    const handleClickViewAll = () => {
        navigate("/product/discountedProductPage", {state : {data}})
    }

    useEffect(() => {
        if (data.length > 0) {
            setDscPlaceholder(false)
            setDataPopulated(true)
        }
    }, [data])

    return (
        <Container fluid className="mt-2 mb-4">
            <React.Fragment>
                <Row>
                    <Col md={12} className="text-start">
                        <div>
                            <Label content="Sale Product" icon="tags" className="fs-5 mb-3" ribbon color="black" />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Carousel keyboard={true} variant="dark" indicators={false}>
                        {
                            !dscPlaceholder ?
                                groupedData.map((group, index) => {
                                    return (
                                        <Carousel.Item key={index}>
                                            <Row>
                                                {group.map((item, i) => (
                                                    <Col lg={2} md={3} sm={6} xs={6} key={i}>
                                                        <ProductCard
                                                            data={item}
                                                            option="dscProduct"
                                                            isWish={wishData.some(wishItem => wishItem.id_product === item.id_product)}
                                                        />
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Carousel.Item>
                                    )
                                })
                                :
                                <Carousel.Item>
                                    <Row className="mt-3">{
                                        Array.from({ length: 6 }, (_, index) => (
                                            <Col lg={2} md={3} sm={6} xs={6} key={index} className="mb-4">
                                                <Card className="text-start">
                                                    <Card.Img variant="top" src="https://via.placeholder.com/500x400.png" />
                                                    <Card.Body>
                                                        <Placeholder as={Card.Title} animation="glow" className="mb-4"      >
                                                            <Placeholder xs={12} />
                                                        </Placeholder>
                                                        <Placeholder as={Card.Text} animation="glow">
                                                            <Placeholder xs={6} className="mb-3" />
                                                            <Placeholder xs={8} className="mb-3" />
                                                            <Placeholder xs={9} />  <Placeholder xs={2} />
                                                        </Placeholder>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))
                                    }</Row>
                                </Carousel.Item>
                        }
                    </Carousel>
                </Row>
            </React.Fragment>
            <Button basic size="small" color="orange" style={dataPopulated ? {display:'block'} : {display:'none'}} className="mt-2 float-end" onClick={handleClickViewAll}>View all products</Button>
        </Container>
    )
}